(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cela-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cela-announcements')) {
    customElements.define('cela-announcements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.controller) return;

        this.controller = new AbortController();
        this.slides = Array.from(this.querySelectorAll('[data-notice-message]'));
        this.index = 0;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.editorPaused = false;
        this.interval = Math.min(12, Math.max(4, Number(this.dataset.interval) || 6)) * 1000;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true';

        if (this.slides.length === 0) return;

        this.show(0);
        this.dataset.ready = 'true';
        if (this.slides.length < 2) return;

        const options = { signal: this.controller.signal };
        this.addEventListener('mouseenter', () => {
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.schedule();
        }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.isConnected || !this.controller) return;
            this.focused = this.contains(document.activeElement);
            this.schedule();
          });
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.selectedBlockId = event.detail.blockId;
          this.editorPaused = true;
          this.show(index);
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          if (event.detail?.blockId !== this.selectedBlockId) return;
          this.selectedBlockId = null;
          this.editorPaused = false;
          this.schedule();
        }, options);
        this.motionChanged = () => this.schedule();
        this.motionPreference.addEventListener('change', this.motionChanged);
        this.schedule();
      }

      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
      }

      schedule() {
        window.clearTimeout(this.timer);
        if (!this.isConnected || this.slides.length < 2 || !this.autoplay || this.motionPreference.matches || this.hovered || this.focused || this.editorPaused || document.hidden) return;
        this.timer = window.setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, this.interval);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
        if (this.motionChanged) this.motionPreference?.removeEventListener('change', this.motionChanged);
        this.motionChanged = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-collage-split"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-smooth-scroll]').forEach((link) => {
    if (link.dataset.smoothScrollBound === 'true') return;

    link.dataset.smoothScrollBound = 'true';

    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');

      if (!href || href.charAt(0) !== '#') return;

      const target = document.querySelector(href);

      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', href);
      }

      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }

      target.focus({ preventScroll: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-browser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-browser')) {
    customElements.define('shop-browser', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.shop-browser__grid');
        this.cards = [...this.querySelectorAll('[data-resource-kind]')];
        this.cards.forEach((card, index) => card.dataset.resourceOrder = index);
        this.search = this.querySelector('[data-shop-search]');
        this.sort = this.querySelector('[data-shop-sort]');
        this.mode = this.modeFromHash();
        this.handleClick = (event) => {
          const link = event.target.closest('[data-shop-mode]');
          if (link && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            this.mode = link.dataset.shopMode;
            history.pushState(null, '', link.getAttribute('href'));
            this.update();
          }
          if (event.target.closest('[data-shop-clear]')) {
            this.search.value = '';
            this.update();
            this.search.focus();
          }
        };
        this.handleInput = () => this.update();
        this.handleHistory = () => { this.mode = this.modeFromHash(); this.update(); };
        this.handleSectionLoad = () => this.update();
        this.handleSectionSelect = (event) => {
          if (event.target.querySelector('[data-shop-bundles]')) {
            this.mode = 'bundles';
            this.update();
          }
        };
        this.addEventListener('click', this.handleClick);
        this.search.addEventListener('input', this.handleInput);
        this.sort.addEventListener('change', this.handleInput);
        window.addEventListener('popstate', this.handleHistory);
        window.addEventListener('hashchange', this.handleHistory);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.search?.removeEventListener('input', this.handleInput);
        this.sort?.removeEventListener('change', this.handleInput);
        window.removeEventListener('popstate', this.handleHistory);
        window.removeEventListener('hashchange', this.handleHistory);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        this.bundleWrapper?.removeAttribute('data-shop-hidden');
      }
      modeFromHash() {
        return location.hash === '#shop-bundles' ? 'bundles' : location.hash === '#shop-products' ? 'products' : 'all';
      }
      bundleSection() {
        return this.closest('main')?.querySelector('[data-shop-bundles]')?.closest('.shopify-section');
      }
      update() {
        const bundles = this.bundleSection();
        this.bundleWrapper = bundles;
        this.dataset.shopView = this.mode;
        const compareMode = this.mode === 'bundles' && bundles;
        if (bundles) bundles.toggleAttribute('data-shop-hidden', !compareMode);
        this.querySelector('.shop-browser__catalog').hidden = Boolean(compareMode);
        this.querySelector('.shop-browser__tools').hidden = Boolean(compareMode);
        this.querySelectorAll('[data-shop-mode]').forEach(link => {
          if (link.dataset.shopMode === this.mode) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const words = normalize(this.search.value).trim().split(/\s+/).filter(Boolean);
        const sorted = [...this.cards].sort((a, b) => {
          if (this.sort.value === 'price-ascending') return Number(a.dataset.resourcePrice) - Number(b.dataset.resourcePrice);
          if (this.sort.value === 'price-descending') return Number(b.dataset.resourcePrice) - Number(a.dataset.resourcePrice);
          if (this.sort.value === 'title') return a.dataset.resourceTitle.localeCompare(b.dataset.resourceTitle);
          return Number(a.dataset.resourceOrder) - Number(b.dataset.resourceOrder);
        });
        let visibleCount = 0;
        sorted.forEach(card => {
          const kindMatches = this.mode === 'all' || (this.mode === 'products' ? card.dataset.resourceKind === 'product' : card.dataset.resourceKind === 'bundle');
          const matches = kindMatches && words.every(word => normalize(card.dataset.resourceTitle).includes(word));
          card.hidden = !matches;
          if (matches) visibleCount++;
          this.grid.appendChild(card);
        });
        this.querySelector('.shop-browser__empty').hidden = visibleCount > 0;
        const count = compareMode ? bundles.querySelectorAll('.bundle-ladder__card').length : visibleCount;
        const label = compareMode ? this.dataset.bundlesLabel : this.dataset.resultsLabel;
        this.querySelector('.shop-browser__status').textContent = `${count} ${label}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
